//! save scroll position

import { useEffect } from 'react';

export function useScrollRestore({ dep = [], working = true }) {
	useEffect(() => {
		if (working) {
			const saveScroll = () => {
				sessionStorage.setItem('scrollY', window.scrollY);
			};
			window.addEventListener('scroll', saveScroll);

			const y = sessionStorage.getItem('scrollY');
			if (y) {
				window.scrollTo(0, Number(y));
			}
		}

		return () => {
			const saveScroll = () => {
				sessionStorage.setItem('scrollY', window.scrollY);
			};

			window.removeEventListener('scroll', saveScroll);
		};
	}, [...dep]);
}
